import { render, staticRenderFns } from "./ExamAnswers.vue?vue&type=template&id=5bfc45d0"
import script from "./ExamAnswers.vue?vue&type=script&lang=js"
export * from "./ExamAnswers.vue?vue&type=script&lang=js"
import style0 from "./ExamAnswers.vue?vue&type=style&index=0&id=5bfc45d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports